exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon--statflo{width:105px;fill:#fff}\n", ""]);

// exports
